import React, { useContext } from "react";
import { AuthContext } from "../context/Auth";
import { Navigate } from "react-router-dom";

export const AdminOnly = ({ children }) => {
    const { signed, isAdmin } = useContext(AuthContext);

    if (!signed) {
        return <Navigate to="/" />;
    }

    if (!isAdmin) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-gray-100">
                <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full">
                    <div className="text-center">
                        <h2 className="text-2xl font-bold text-red-600 mb-4">
                            Acesso Negado
                        </h2>
                        <p className="text-gray-600 mb-6">
                            Você não tem permissão para acessar esta área. 
                            Apenas administradores podem acessar o painel administrativo.
                        </p>
                        <button
                            onClick={() => window.location.href = '/'}
                            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                        >
                            Voltar ao Login
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return children;
}; 